import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from "../../components/auth/AuthLayout";
import AuthForm from "../../components/auth/AuthForm";
import FormField from "../../components/auth/FormField";
import Button from "../../components/ui/button/Button";
import { supabase } from "../../integrations/supabase/client";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const emailInputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  useEffect(() => {
    // Check if user is already logged in
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        console.log('User is already logged in');
        navigate('/');
      }
    });
  }, [navigate]);

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);
    setIsLoading(true);
    
    const email = emailInputRef.current?.value || '';

    if (!email) {
      setErrorMessage('Please enter your email address');
      setIsLoading(false);
      return;
    }

    try {
      const redirectTo = `${window.location.origin}/update-password`;
      console.log("Redirecting to:", redirectTo);
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo
      });

      if (error) {
        setErrorMessage(error.message);
      } else {
        setSuccessMessage('Password reset instructions have been sent to your email address. Please check your inbox.');
      }
    } catch (err) {
      setErrorMessage('An unexpected error occurred. Please try again.');
      console.error('Password reset error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Enter your email to reset your password"
      metaTitle="Forgot Password | PDF ConvertOne"
      metaDescription="Reset your PDF ConvertOne account password"
    >
      <AuthForm
        onSubmit={handleResetPassword}
        errorMessage={errorMessage}
        successMessage={successMessage}
        bottomContent={
          <p className="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
            Remember your password? {""}
            <Link
              to="/signin"
              className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
            >
              Sign In
            </Link>
          </p>
        }
      >
        <FormField
          label="Email"
          placeholder="alex.smith@example.com"
          ref={emailInputRef}
          required
        />
        
        <div>
          <Button className="w-full" size="sm" disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Reset Password'}
          </Button>
        </div>
      </AuthForm>
    </AuthLayout>
  );
} 